<app-loader></app-loader>
<div *ngIf="logged()" class="div-logout"><button class="logout" (click)="logout()">Logout</button></div>
<router-outlet></router-outlet>
